"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var CoauthorIcon_1 = __importDefault(require("../../../Icons/Notifications/CoauthorIcon"));
var i18N = {
    en: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "You've been invited to collaborate as a co-author on a published proposal. Accept it or reject it",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "here"),
            ".")); },
        title: 'Co-author request received'
    },
    es: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Has sido invitado a colaborar como coautor en un propuesta publicada. Aceptala o rechazala",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "aqui"),
            ".")); },
        title: 'Solicitud de coautoria'
    },
    zh: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u60A8\u53D7\u9080\u4F5C\u4E3A\u5171\u540C\u4F5C\u8005\u53C2\u4E0E\u4E00\u9879\u5DF2\u53D1\u8868\u63D0\u6848\u7684\u5408\u4F5C.",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "\u5728\u6B64\u63A5\u53D7\u6216\u62D2\u7EDD"),
            ".")); },
        title: '收到共同作者申请'
    }
};
var GovernanceCoauthorRequestedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(CoauthorIcon_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" },
            i18N[locale].title,
            ' ',
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, notification.metadata.proposalTitle)),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.link))));
};
exports.default = GovernanceCoauthorRequestedNotification;
